export default __webpack_public_path__ + "static/media/aws-kinesis.b2775670.svg";